/* eslint-disable no-console */
import React from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import CameraIcon from '@material-ui/icons/PhotoCamera';
import CheckIcon from '@material-ui/icons/Check';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';

import {
  ImageContainer,
  DocumentContainer,
  ImageDocumentContainer,
  DistributorImage,
  DocumentText,
  ContentTerms,
} from '../../styledComponents';

const SelfieStep = ({
  showIdentityValidator,
  currentlyFaceCapture,
  selfie,
  errorFaceCapture,
  errorSelfie,
  successSelfie,
  faceComponent,
  onSetCurrentlyFaceCapture,
  identityValidationAttempts,
  validationAttempt,
  onTermsAgreedChange,
  onTermsAgreedOpen,
}) => (
  <>
    <h1>Validación de identidad</h1>
    {currentlyFaceCapture && showIdentityValidator && faceComponent}
    {currentlyFaceCapture && showIdentityValidator && (
      <div id="face_component"></div>
    )}

    {!currentlyFaceCapture && !selfie && (
      <>
        {showIdentityValidator ? (
          <>
            <ImageContainer onClick={() => onSetCurrentlyFaceCapture(true)}>
              <DocumentContainer>
                <ImageDocumentContainer>
                  <CameraIcon color="#994878" />
                </ImageDocumentContainer>
              </DocumentContainer>
            </ImageContainer>
            <DocumentText>Capturar Selfie</DocumentText>
          </>
        ) : (
          <>
            <ImageContainer onClick={() => console.log()}>
              <DocumentContainer>
                <ImageDocumentContainer>
                  <CheckIcon color="#994878" />
                </ImageDocumentContainer>
              </DocumentContainer>
            </ImageContainer>
            <DocumentText>Identidad validada</DocumentText>
          </>
        )}
      </>
    )}

    {!currentlyFaceCapture && selfie && (
      <>
        {errorFaceCapture ? (
          <>
            <ImageContainer
              onError={errorFaceCapture}
              onClick={() => onSetCurrentlyFaceCapture(true)}
            >
              <DocumentContainer>
                <ImageDocumentContainer>
                  <>
                    <DistributorImage
                      alt="ineFrente.png"
                      src={`data:image/jpeg;base64,${selfie}`}
                    />
                  </>
                </ImageDocumentContainer>
              </DocumentContainer>
            </ImageContainer>
            <DocumentText>{errorSelfie}</DocumentText>
          </>
        ) : (
          <>
            <ImageContainer>
              <DocumentContainer>
                <ImageDocumentContainer>
                  <>
                    <DistributorImage
                      alt="ineFrente.png"
                      src={`data:image/jpeg;base64,${selfie}`}
                    />
                  </>
                </ImageDocumentContainer>
              </DocumentContainer>
            </ImageContainer>
            <DocumentText>{successSelfie}</DocumentText>
          </>
        )}
      </>
    )}

    {!currentlyFaceCapture && errorSelfie && (
      <>
        <Button
          variant="outlined"
          color="primary"
          onClick={() => onSetCurrentlyFaceCapture(true)}
          style={{ marginTop: 12 }}
        >
          Reintentar selfie
        </Button>
      </>
    )}

    {/* <h1>Confirmar solicitud</h1> */}
    {validationAttempt <= identityValidationAttempts && (
      <ContentTerms>
        <FormControlLabel
          control={<Checkbox name="accept" color="primary" />}
          className="accept-check"
          onChange={event => onTermsAgreedChange(event.target.checked)}
        />
        <Button onClick={onTermsAgreedOpen}>
          Acepto términos y condiciones.
        </Button>
      </ContentTerms>
    )}
  </>
);

SelfieStep.propTypes = {
  showIdentityValidator: PropTypes.bool,
  currentlyFaceCapture: PropTypes.bool,
  selfie: PropTypes.string,
  errorFaceCapture: PropTypes.bool,
  errorSelfie: PropTypes.string,
  successSelfie: PropTypes.string,
  faceComponent: PropTypes.node,
  onSetCurrentlyFaceCapture: PropTypes.func,
  identityValidationAttempts: PropTypes.number,
  validationAttempt: PropTypes.string,
  onTermsAgreedChange: PropTypes.func,
  onTermsAgreedOpen: PropTypes.func,
};

SelfieStep.defaultProps = {
  showIdentityValidator: true,
  currentlyFaceCapture: false,
  selfie: null,
  errorFaceCapture: false,
  errorSelfie: '',
  successSelfie: '',
  faceComponent: null,
  onSetCurrentlyFaceCapture: () => {},
  identityValidationAttempts: 0,
  validationAttempt: '',
  onTermsAgreedChange: () => {},
  onTermsAgreedOpen: () => {},
};

export default SelfieStep;
